export const RELOAD_TIMESTAMP_KEY = "ark:reloadedForStaleChunk";
export const RELOAD_COOLDOWN_MS = 30_000;

const STALE_CHUNK_MESSAGES = [
  "Failed to fetch dynamically imported module",
  "error loading dynamically imported module",
  "Importing a module script failed",
];

export function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : typeof error === "string" ? error : "";
  return STALE_CHUNK_MESSAGES.some((pattern) => message.includes(pattern));
}

function hasReloadedWithinCooldown(): boolean {
  try {
    const value = sessionStorage.getItem(RELOAD_TIMESTAMP_KEY);
    if (value === null) return false;
    const at = Number.parseInt(value, 10);
    return Number.isFinite(at) && Date.now() - at < RELOAD_COOLDOWN_MS;
  } catch {
    return true;
  }
}

export function reloadForStaleChunkWithCooldown(
  reload: () => void = () => window.location.reload(),
): boolean {
  if (hasReloadedWithinCooldown()) return false;
  try {
    sessionStorage.setItem(RELOAD_TIMESTAMP_KEY, String(Date.now()));
  } catch {
    return false;
  }
  reload();
  return true;
}
